<template>
  <div class="space-y-2">
    <!-- Week Header (clickable to collapse/expand) -->
    <button
      @click="$emit('toggle')"
      class="sticky top-0 z-10 bg-gray-100 dark:bg-gray-700 px-3 sm:px-4 py-2 sm:rounded-lg shadow-sm w-full text-left hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors flex items-center justify-between"
    >
      <h2 class="font-semibold text-gray-700 dark:text-gray-200">{{ weekLabel }}</h2>
      <ChevronDownIcon
        class="h-5 w-5 text-gray-500 dark:text-gray-400 transition-transform"
        :class="isExpanded ? '' : '-rotate-90'"
      />
    </button>

    <!-- Prospects in this week (collapsible) -->
    <template v-if="isExpanded">
      <slot></slot>
    </template>
  </div>
</template>

<script setup>
import { ChevronDownIcon } from '@heroicons/vue/24/outline'

defineProps({
  weekKey: {
    type: String,
    required: true
  },
  weekLabel: {
    type: String,
    required: true
  },
  isExpanded: {
    type: Boolean,
    default: true
  }
})

defineEmits(['toggle'])
</script>
